import { render, staticRenderFns } from "./VpsPendingApproval.vue?vue&type=template&id=71816dcd"
import script from "./VpsPendingApproval.vue?vue&type=script&lang=js"
export * from "./VpsPendingApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports